import type { FunctionComponent } from 'react';

type FooterLink = {
  title: string;
  href: string;
  icon?: FunctionComponent;
};

export const SOCIAL_LINKS: Array<FooterLink> = [
  { title: 'Instagram', href: 'https://www.instagram.com/listening/' },
  { title: 'Facebook', href: 'https://www.facebook.com/listeningapp/' },
  { title: 'TikTok', href: 'https://www.tiktok.com/@thelisteningapp' },
  { title: 'LinkedIn', href: 'https://www.linkedin.com/company/listeningapp' },
  { title: 'Youtube', href: 'https://www.youtube.com/@listeningapp' },
];

export const LEGAL_LINKS: Array<FooterLink> = [
  { title: 'Privacy Policy', href: '/privacy' },
  { title: 'Terms of Service', href: '/terms' },
];
